

























import Vue from "vue";
import UserAvatar from "@/components/buttons/UserAvatar.vue";
import UserMenu from "@/components/menus/user-menu/UserMenu.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import storeHelper from "@/store/store-helper";
import PrivacyPolicy from "./PrivacyPolicy.vue";
import Utils from "@/utils";
import { Controllers, ProblemResult } from "@infoland/iprova-api";
import { FeatureType } from "@/enums";

const allow_saml2_logoff = "allow_saml2_logoff";

export default Vue.extend({
    name: "ToolbarUser",
    components: {
        UserAvatar,
        UserMenu,
        ZenyaDialog,
        PrivacyPolicy
    },
    props: {
        isAnonymousUser: Boolean,
        portalId: Number
    },
    data: () => {
        return {
            showPrivacyPolicyDialog: false,
            showUserMenu: false,
            isLoading: false,
            showApps: null,
            showLogoff: null,
            showMyControlTests: null,
            showMyControlTestReviews: null,
            showMyFindings: null,
            risk2022Enabled: null
        };
    },
    watch: {
        showPrivacyPolicyDialog: function (newValue: boolean) {
            storeHelper.siteStore.setIsDialogDisplayed(newValue);
        }
    },
    computed: {
        userFullName(): string {
            return this.$user?.name;
        },
        isAutoLogon(): boolean {
            return Utils.getCookie("AutomaticallyLoggedIn") == "1";
        },
        isAdministrator(): Boolean {
            return Utils.isAdministrator(this.$user.user_id);
        }
    },
    methods: {
        openPrivacy() {
            this.showPrivacyPolicyDialog = true;
        },
        //NOTE: This should be temporary until we are converting the portal project and uses the new shadow dom topbar
        async handleUserAvatarClickAsync() {
            try {
                this.showUserMenu = false;
                this.isLoading = true;

                if (
                    this.showApps == null ||
                    this.showLogoff == null ||
                    this.showMyControlTests == null ||
                    this.showMyControlTestReviews == null ||
                    this.showMyFindings == null
                ) {
                    const promises: Promise<unknown>[] = [];
                    const risk2022Enabled = await storeHelper.settingsStore.getSettingAsync<boolean>("risk2022_enabled");
                    if (risk2022Enabled) {
                        promises.push(
                            Controllers.GenericController.getAsync<unknown[]>(
                                "risks/controls?minimum_role=control_tester&control_testing_enabled=true&limit=1"
                            ).then(value => {
                                this.showMyControlTests = value?.length > 0;
                            })
                        );
                        promises.push(
                            Controllers.GenericController.getAsync<unknown[]>(
                                "risks/controls?minimum_role=control_test_reviewer&control_test_reviewing_enabled=true&limit=1"
                            ).then(value => {
                                this.showMyControlTestReviews = value?.length > 0;
                            })
                        );
                    } else {
                        this.showMyControlTests = false;
                        this.showMyControlTestReviews = false;
                    }

                    const audit2024Enabled = await storeHelper.FeaturesStore.featureByType(FeatureType.audits_2024);
                    if (audit2024Enabled.enabled) {
                        promises.push(
                            Controllers.GenericController.getAsync<unknown[]>(
                                `findings?limit=1&&states=new,in_progress&assigned_to_user_ids=${this.$user.user_id}`
                            ).then(value => {
                                this.showMyFindings = value?.length > 0;
                            })
                        );
                    } else {
                        this.showMyFindings = false;
                    }

                    await Promise.allSettled([
                        this.getShowLogoffAsync(),
                        storeHelper.appsStore.loadApps().then(value => {
                            this.showApps = !this.isAdministrator && value?.length > 0;
                        }),
                        promises
                    ]);
                }
            } catch (error) {
                console.error("Error loading user menu data", error);
            } finally {
                this.$nextTick(() => {
                    this.isLoading = false;
                    this.showUserMenu = true;
                });
            }
        },
        async getShowLogoffAsync(): Promise<void> {
            // shortcut when not autologon
            if (!this.isAutoLogon) {
                this.showLogoff = true;
                return;
            }
            this.showLogoff = await storeHelper.settingsStore.getSettingAsync<boolean>(allow_saml2_logoff);
        }
    }
});
